import { RouteRecordRaw } from "vue-router";
import ScreenView from "@/views/screen/ScreenView.vue";

export const screenRoutes: Array<RouteRecordRaw> = [
  {
    path: "/screen",
    name: "screen",
    component: ScreenView,
    children: [
      // 期货知识
      {
        path: "futuresKnowledge",
        name: "futuresKnowledgeView",
        children: [
          {
            path: "index",
            component: () =>
              import("@/views/screen/futuresKnowledge/fkIndex.vue"),
          },
          {
            path: "item2",
            component: () =>
              import("@/views/screen/futuresKnowledge/itemPage2.vue"),
          },
          {
            path: "item22",
            component: () =>
              import("@/views/screen/futuresKnowledge/itemPage22.vue"),
          },
          {
            path: "item5",
            component: () =>
              import("@/views/screen/futuresKnowledge/itemPage5.vue"),
          },
        ],
      },
      {
        path: "termOfCooperation",
        name: "termOfCooperationView",
        component: () =>
          import("@/views/screen/termOfCooperation/termOfCooperation.vue"),
      },
      {
        path: "termOfCooperation2",
        name: "termOfCooperation2View",
        component: () =>
          import("@/views/screen/termOfCooperation/termOfCooperation2.vue"),
      },
      {
        path: "reviewExpert",
        name: "reviewExpertView",
        component: () => import("@/views/screen/reviewExpert/reviewExpert.vue"),
      },
    ],
  },
];
